import * as toolbox from 'components/common/toolbox';
import * as types from './action-types';
import _ from 'lodash';
import firebase from 'firebase/compat/app';
import { phone } from 'phone';

const firestore = firebase.firestore();

/*-----------------------------------------------*/
/*  Activity Log
/*-----------------------------------------------*/

export function saveActivity(handle, description, id, type, userId, mostRecent) {

    return dispatch => {

        dispatch({ type: types.ACTIVITY_LOG + '_SAVE_PENDING' });

        var activity = { date: new Date(), description, id, type };
        if (mostRecent) activity.mostRecent = true;


        firestore.collection(handle + '/users/users/' + userId + '/activity-log').add(activity).then((doc) => {
            dispatch({ type: types.ACTIVITY_LOG + '_SAVE_FULFILLED' });
        }).catch((error) => {
            toolbox.process_error(error, 'Activity NOT Logged!');
        });
    };
}

/*-----------------------------------------------*/
/*  Error Log
/*-----------------------------------------------*/

export function logError(handle, error) {

    return async dispatch => {

        dispatch({ type: types.ERROR_LOG + '_SAVE_PENDING' });

        var existingRef = await firestore.collection(handle + '/error-log/error-log/').where('message', '==', error.message).where('pathname', '==', error.pathname).where('stack', '==', error.stack).where('resolved', '==', false).get();
        var existing = { ...existingRef.docs[0]?.data(), id: existingRef.docs[0]?.id };

        if (!existing?.id) {
            firestore.collection(handle + '/error-log/error-log/').add(error).then((doc) => {
                dispatch({ type: types.ERROR_LOG + '_SAVE_FULFILLED' });
            }).catch((error) => {
                toolbox.process_error(error, 'Error NOT Logged!');
            });
        } else {
            dispatch({ type: types.ERROR_LOG + '_SAVE_FULFILLED' });
        }
    };
}

/*-----------------------------------------------*/
/*  Messages
/*-----------------------------------------------*/

export function getBlastContacts(handle, recipients, departmentId, callback) {

    return async dispatch => {

        var notifications = [];
        var profileDocs = await firestore.collection(handle + '/profiles/profiles').where('type', '==', 'employee').where('deleted', '==', false).get();
        
        var profiles = [];
        profileDocs.forEach((doc) => {
            profiles.push({ ...doc.data(), id: doc.id });
        });

        var contacts = [];
        for (let profile of profiles) {
            var contactsDocs = await firestore.collection(handle + '/contacts/contacts').where('profileIds', 'array-contains', profile.id).where('deleted', '==', false).get();
            contactsDocs.forEach((doc) => {
                contacts.push({ ...doc.data(), id: doc.id, departmentId: profile.departmentId });
            });
        }

        switch (recipients) {
            case 'employees':
                for (let contact of contacts) {
                    let result = (parseInt(departmentId)) ? (contact.departmentId == departmentId) : true;
                    if (result) pushContact(contact); // '8' == Trucker
                };
                break;
            default:
        }

        if (notifications.length) {
            if (typeof callback === 'function') callback(notifications);
        } else {
            window.toastr.error('There are no Recipients in the current search.', 'Email NOT Sent!');
        }

        function pushContact(contact) {
            let notif = {
                id: contact.id,
                name: contact.firstName + ' ' + contact.lastName,
                mobile: (contact.notifyViaSms) ? phone(contact.mobile, { country: 'USA' }).phoneNumber : 'opted-out',
                email: (contact.notifyViaEmail) ? contact.email : 'opted-out',
                userId: (contact.notifyViaEmail) ? contact.email : null,
            };
            if (!_.find(notifications, (o) => { return o.id == contact.id; })) notifications.push(notif);
        }
    };
}
export function sendNotificationBlast(handle, messageId, companySettings, contacts, subject, message, callback) {

    return async dispatch => {

        if (companySettings.smsPhoneNumber && companySettings.smsLogo) {

            var emailMessage = message.replace(/(?:\r\n|\r|\n)/g, '<br>');
            emailMessage = "<h2>Bio Source Corp.</h2>" + emailMessage;

            return firestore.collection(handle + '/notifications/notifications').add({
                messageId: messageId,
                contacts: contacts,
                subject: subject,
                message: message,
                emailMessage: emailMessage,
                fromSms: companySettings.smsPhoneNumber,
                fromEmail: (companySettings.email) ? companySettings.companyName + ' <' + companySettings.email + '>' : 'Mobile Track Systems <no-reply@mobiletrack.systems>',
                mediaUrl: companySettings.smsLogo,
                type: 'notification',
                created: new Date(),

            }).then(async (docRef) => {
                window.toastr.success('The Notification has been queued for delivery.', 'Notification Queued!');
                if (typeof callback === 'function') callback();
            });

        } else {
            window.toastr.error('SMS phone number and Logo have not been defined in Company Settings.', 'Notifications Not Sent!');
        }
    };
}

export function subMessages(handle) {

    return dispatch => {

        dispatch({ type: types.MESSAGES + '_PENDING' });

        const unsubscribe = firestore.collection(handle + '/notifications/messages').orderBy('created', 'desc').onSnapshot((querySnapshot) => {
            const messages = [];
            querySnapshot.forEach((doc) => {
                messages.push({ ...doc.data(), id: doc.id });
            });

            dispatch({ type: types.MESSAGES + '_FULFILLED', data: messages, unsubscribe });
        });
    };
}

export function saveMessage(handle, message, docId, callback) {

    return dispatch => {

        dispatch({ type: types.MESSAGES + '_SAVE_PENDING' });

        const ref = firestore.collection(handle + '/notifications/messages');

        // Update document if Document ID is present.
        // Or, add new document.
        const execute = (message) => {
            if (docId != '0') {
                return ref.doc(docId).update(message);
            }
            message.modified = new Date();
            message.created = new Date();
            message.subject_insensitive = message.subject.toLowerCase();

            return ref.add(message);
        };

        const successMessage = (docId != '0') ? 'Updated' : 'Saved';

        return execute(message).then((docRef) => {
            const id = (docId != '0') ? docId : docRef.id;
            if (typeof callback === 'function') callback(id);
            window.toastr.success(`Message ${successMessage} successfully!`, `Message ${successMessage}`);
            dispatch({ type: types.MESSAGES + '_SAVE_FULFILLED' });

        }).catch((error) => {
            dispatch({ type: types.MESSAGES + '_SAVE_FULFILLED' });
            window.toastr.error(error.message, 'Message Error');
        });
    };
}

export function deleteMessage(handle, id, callback) {

    return dispatch => {
        dispatch({ type: types.MESSAGES + '_SAVE_PENDING' });

        return firestore.collection(handle + '/notifications/messages').doc(id).delete().then((_) => {
            dispatch({ type: types.MESSAGES + '_SAVE_FULFILLED' });
            if (typeof callback == "function") callback();
        }).catch((error) => {
            window.toastr.error(error.message, 'Delete Error');
            dispatch({ type: types.MESSAGES + '_SAVE_FULFILLED' });
        });
    };

}

// export function selectMessage(id) {
//     return dispatch => {
//         dispatch({ type: types.MESSAGE_ID + '_FULFILLED', data: id });
//     };
// }

// export function clearMessageId() {
//     return dispatch => {
//         dispatch({ type: types.MESSAGE_ID + '_CLEAR' });
//     };
// }

// export function clearMessages() {
//     return dispatch => {
//         dispatch({ type: types.MESSAGES + '_CLEAR' });
//         dispatch({ type: types.MESSAGE_ID + '_CLEAR' });
//     };
// }


export function transform(handle) {

    return async dispatch => {

        // var profiles = [];
        // const snapshot = await firestore.collection(handle + '/profiles/profiles').get();
        // snapshot.forEach((doc) => {
        //     profiles.push({ ...doc.data(), id: doc.id });
        // });

        // for (let profile of profiles) {

        //     let contactId = Object.keys(profile.contacts)[0];

        //     const contactDoc = await firestore.collection(handle + '/contacts/contacts').doc(contactId).get();
        //     var contact = { ...contactDoc.data(), id: contactDoc.id  };

        //     const userDoc = await firestore.collection(handle + '/users/users').doc(contact.email).get();
        //     var user = { ...userDoc.data(), id: userDoc.id  };

        //     profile.schedule = user.schedule;
        //     delete profile.editedBy;
        //     delete user.schedule
        //     delete user.showOnSchedule;
        //     delete user.editedBy;

        //     profile.departmentId = contact.departmentId;
        //     delete contact.departmentId;
        //     delete profile.department;
        //     delete contact.notes;

        //     profile.roles = user.roles;
        //     profile.tags = contact.tags ?? null;
        //     delete contact.tags;

        //     console.log(profile);
        //     console.log(contact);
        //     console.log(user);

        //     await firestore.collection(handle + '/profiles/profiles').doc(profile.id).set(profile);
        //     await firestore.collection(handle + '/contacts/contacts').doc(contact.id).set(contact);
        //     await firestore.collection(handle + '/users/users').doc(user.id).set(user);
        // }
    };
}
